var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "the-header-line" }, [
    _c(
      "div",
      { staticClass: "the-header-line__inner container" },
      [
        _c("div", { staticClass: "d-flex align-center justify-center" }, [
          _c("button", {
            staticClass:
              "the-header-line__hamburger-btn ui-icon-menu pr-3 py-1",
            attrs: {
              type: "button",
              "aria-hidden": "false",
              "data-role": "none",
              "data-qa": "the_header_hamburger_btn",
            },
            on: { click: _setup.handleClickHamburger },
          }),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "d-flex",
              attrs: { href: "/", "data-qa": "the_header_logo_link" },
            },
            [
              _c("img", {
                staticClass: "the-header-line__logo",
                class: {
                  "the-header-line__logo--event": _setup.showEventSiteLogo,
                },
                attrs: { src: _setup.siteLogo.src, alt: _setup.siteLogo.alt },
              }),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(_setup.HeaderAnalyses),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }